
export class ResultListOption {
    // Pagination
    public limit: number = null;

    // Type de sélection (multi ou single ou falsey pour aucune)
    private _selectionType: string = 'falsey';

    public get selectionType(): string {
        return this._selectionType;
    }
    public set selectionType(value: string) {
        if (value != 'multi' && value != 'single' && value != 'falsey') {
            console.error("Result-list option selectionType non autorisé : " + value + ". Seul sont autorisés : multi, single, falsey. la valeur est mise à falsey par défaut.");
            value = 'falsey';
        }
        this._selectionType = value;
    }

    // Permet l'edition des données d'une ligne de la table
    public inlineEdit: boolean = false;

    // Permet de supprimmer une ligne de la table
    public inlineDelete: boolean = false;

    // Permet d'ajouter une ligne de la table
    public addRowEnabled: boolean = false;

    // Export
    public exportEnabled: boolean = false;

    // Footer
    public hasFooter: boolean = true;

    // Troncature de l'affichage des donnees des colonnes
    public truncatureArgs: any[] = [];

    // Taille de la colonne des actions
    public actionColumnWith: number = 100;

    // input recherche visible
    public hasFilter: boolean = true;

    // Hauteur de ligne automatique (sinon 35)
    public rowHeightAuto: boolean = false;

    // alternate row colors
    public alternateRowColors: boolean = false;

    constructor(fields?: Partial<ResultListOption>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}

export class ResultListTranslation {
    public emptyMessage: string = '';
    public selectedMessage: string = '';
    public totalMessage: string = '';

    constructor(fields?: Partial<ResultListTranslation>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}

export class ResultListColumn {
    public identifier:string;
    public filter: boolean = false;//La colonne fait-elle partie de la recherche ?
    public prop: string; //Valeur à afficher
    public name: string; //Nom de la colonne
    public width: number;
    public type: string;
    public checkboxable: boolean = false;
    public headerCheckboxable: boolean = false;
    public extraLines: ResultListColumnExtraLine[] = [];
    public translate:boolean = false;
    public translateParams:any = {};

    constructor(fields?: Partial<ResultListColumn>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}

export class ResultListColumnExtraLine {
    public prop: string;
    public label: string;
    public small: boolean = false;
    public bold: boolean = false;
    public italic: boolean = false;
    public underline: boolean = false;
    public strike: boolean = false;
    public translateParams:any = {};

    constructor(fields?: Partial<ResultListColumnExtraLine>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}

export class ResultListAction {
    public icon: string;
    public states: ResultListActionStates;
    public action: Function;
    public params: string[] = [];
    public title: string;
    public colorBox: boolean = false;
    public colorField: string;
    public name: string = '';
    public disabled:string;

    constructor(fields?: Partial<ResultListAction>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}


export class ResultListActionStates {
    public active: ResultListActionState = new ResultListActionState();
    public inactive: ResultListActionState = new ResultListActionState();

    constructor(fields?: Partial<ResultListActionStates>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}

export class ResultListActionState {
    public icon: string;
    public field: string;
    public value: any;

    constructor(fields?: Partial<ResultListActionState>) {
        if (fields) {
            Object.assign(this, fields);
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/result-list/models/result-list.ts